export const hasValidationError = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.some(hasValidationError);
  }

  if (value && typeof value === 'object') {
    return Object.values(value).some(hasValidationError);
  }

  return Boolean(value);
};
